import { createTheme } from '@mantine/core';

export const theme = createTheme({
  scale: 1.6,
  defaultRadius: 'sm'
  // loader: 'dots',
});
